import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { StorageServices } from 'services/storage';
import { ROLE } from 'const/common';
import { NewMessageProvider } from 'contexts/newMessage';

const storage = new StorageServices();

/**
 *
 * RequireAuth Component check auth
 *
 * */
export function RequireAuth({ children }: { children: ReactElement }) {
  const hasToken = storage.getAccessToken();
  const role = storage.getRole();

  if (!hasToken || role === ROLE.ADMIN || role === ROLE.ROOT_ADMIN) {
    return <Navigate to={'/login'} />;
  }

  return <NewMessageProvider>{children}</NewMessageProvider>;
}

/**
 *
 * RequireAdminAuth Component check auth
 *
 * */
export function RequireAdminAuth({ children }: { children: ReactElement }) {
  const hasAdminToken = storage.getAccessToken();
  const role = storage.getRole();

  if (!hasAdminToken || role === ROLE.USER) {
    return <Navigate to={'/admin/login'} />;
  }

  return <NewMessageProvider>{children}</NewMessageProvider>;
}
